import httpClient from "@/services/httpClient";
import {
    server, trademark_const
} from "@/services/constants";

export const getnotice_code = () => {
    return httpClient.get(`${trademark_const.trademark_url}/` + server.NOTICE + `/getnotice_code`);
};

export const getnotice_codeByobjecttype_id = (id) => {
    return httpClient.get(`${trademark_const.trademark_url}/` + server.NOTICE + `/getnotice_code_byobjecttype_id/${id}`);
};

export const getnoticeByID = (id) => {
    return httpClient.get(`${trademark_const.trademark_url}/` + server.NOTICE + `/getnoticebyid/${id}`);
};